import React, { useState } from "react";
import { API, graphqlOperation } from "aws-amplify";
import { createFeedbackCategory } from "../../../../graphql/mutations";
import SimpleCreateEdit from "../../../Common/Crud/SimpleCreateEdit";
import TextInput from "../../../../components/Common/TextInput";
import * as FeedbackCategoriesConstants from "../../../../graphql/Constants/FeedbackCategories/Types";
import nameChangeHandler from "../../../Common/Crud/formHandlers/nameChangeHandler";
import orderChangeHandler from "../../../Common/Crud/formHandlers/orderChangeHandler";
import nameOnlyFormsValidationHandler from "../../../Common/Crud/formHandlers/nameOnlyFormsValidationHandler";
import * as CrudActionTypes from "../../../../constants/Crud/ActionTypes";
import * as ModelTypes from "../../../../graphql/Constants/ModelTypes";

const FeedbackCategoryCreate = (props) => {
  // states
  const [name, setName] = useState("");
  const [order, setOrder] = useState(0);
  const [inputFieldsDisable, setInputFieldsDisable] = useState(false);
  const [errors, setErrors] = useState({});
  const [createButtonDisableStatus, setCreateButtonDisableStatus] = useState(
    false
  );

  const handleCreateFeedbackCategory = async () => {
    try {
      const input = {
        type: ModelTypes.FeedbackCategory,
        name: name.trim(),
        order: order,
        deletedAt: null,
      };
      await API.graphql(graphqlOperation(createFeedbackCategory, { input }));
      return { result: true, message: `FeedbackCategory created successfully` };
    } catch (error) {
      return { result: false, message: `Error creating FeedbackCategory, ${error}` };
    }
  };

  return (
    <SimpleCreateEdit
      {...props}
      crudActionType={CrudActionTypes.Create}
      returnHandler={() => props.history.push(`/feedbackCategories`)}
      modelName="Feedback Category"
      // createOrUpdateDisableMethod={(modelData) => {
      //   if (modelData.id === FeedbackCategorysConstants.Other.id) return true;
      //   return false;
      // }}
      // createOrUpdateDisabledActions={() => {
      //   setNameInputTextDisable(true);
      // }}
      formSubmissionHandler={handleCreateFeedbackCategory}
      formValidationHandler={() =>
        nameOnlyFormsValidationHandler(
          name,
          "FeedbackCategory",
          false, // we need to exclude the OTHER,
          setCreateButtonDisableStatus,
          setErrors
        )
      }
      setErrorsState={() => setErrors}
      actionButtonDisabledState={createButtonDisableStatus}
    >
      <TextInput
        type="name"
        id="name"
        label="Feedback Category Name"
        placeholder="Enter a Feedback Category name"
        value={name}
        onChange={(e) =>
          nameChangeHandler(
            e,
            "FeedbackCategory",
            false, // we need to exclude the OTHER,
            setName,
            setCreateButtonDisableStatus,
            setErrors
          )
        }
        isRequired={true}
        error={errors.name}
        disabled={inputFieldsDisable}
      />
      <TextInput
        type="number"
        id="order"
        label="Feedback Category Order"
        placeholder="Enter a Feedback Category Order"
        value={order}
        onChange={(e) =>
          orderChangeHandler(
            e,
            "FeedbackCategory",
            setOrder,
            setCreateButtonDisableStatus,
            setErrors
          )
        }
        isRequired={true}
        error={errors.order}
        disabled={inputFieldsDisable}
      />
    </SimpleCreateEdit>
  );
};

export default FeedbackCategoryCreate;
